import {Component, OnInit,} from '@angular/core';
import {NewsService} from '../../../services/news.service';

const lodash = require('lodash');
const moment = require('moment');
moment.locale('es');

@Component({
  selector: 'ngx-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit {
  loading = false;
  readyData = false;
  images = [];
  message = '';
  news = [];
  moment = moment;
  services = [];

  constructor(
    private newsService: NewsService,
  ) {
  }


  async ngOnInit() {
    this.news = [];
    this.services = [];
    this.loading = true;
    await Promise.all([
      this.getNews(),
      this.addCustomNotices(),
      this.addCustomServices()
    ])
    this.news = await lodash.orderBy(this.news, ['date'], ['desc']);
    this.loading = false;
    (<any>window).twttr.widgets.load()
  }

  async getNews() {
    const [error, {data: data}]: any = await this.newsService.get() as any;
    if (error) return alert(error);
    for (const newAux of data) {
      this.news.push({
        ...newAux,
        type: 'image',
        newsType: 'service',
        created_at: moment.unix(newAux.created_at._seconds).format('LL'),
        date: moment.unix(newAux.created_at._seconds).format('YYYY-MM-DD'),
      });
    }
  }

  async addCustomNotices() {
    this.news.push(
      {
        message: '',
        image: '/assets/images/news/lau.jpeg',
        created_at: moment('11/02/2021', 'DD/MM/YYYY').format('LL'),
        date: moment('11/02/2021', 'DD/MM/YYYY').format('YYYY-MM-DD'),
        type: 'image',
        newsType: 'service',
        class: 'image-height-500',
      },
      {
        message: '',
        image: '/assets/images/news/lf.jpeg',
        created_at: moment('11/02/2021', 'DD/MM/YYYY').format('LL'),
        date: moment('11/02/2021', 'DD/MM/YYYY').format('YYYY-MM-DD'),
        type: 'image',
        newsType: 'service',
        class: 'image-height-500',
      },
    );
  }

  async addCustomServices() {
    this.services.push(
      {
        message: `Llego Diciembre y con este mes nuevos cambios en tu plataforma Softgas.
                   Te invitamos a ver el nuevo diseño del modulo de Personal , donde encontraras un  nuevo apartado  “Autorizados”, para facilitar el llenado de tus bitácoras.
                    Conoce como funciona en el siguiente video.<br><br><strong class="text-danger">¡Felices Fiestas!</strong>`,
        image: '<iframe src="https://www.youtube.com/embed/zwhFQipLuTk" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
        created_at: moment('02/12/2020', 'DD/MM/YYYY').format('LL'),
        date: moment('02/12/2020', 'DD/MM/YYYY').format('YYYY-MM-DD'),
        type: 'youtube',
        newsType: 'platform',
      },
      {
        message: `¿Ya conoces las nuevas Bitácoras que Softgas tiene para ti?
                   Descúbrelas en el módulo de bitácoras, una nueva herramienta de administración para tu estación.
                   <br><br><strong class="text-danger">¡Felices Fiestas!</strong>`,
        image: 'https://www.navarrainformacion.es/wp-content/uploads/2017/01/boli-notas-cuaderno.jpg',
        created_at: moment('11/12/2020', 'DD/MM/YYYY').format('LL'),
        date: moment('11/12/2020', 'DD/MM/YYYY').format('YYYY-MM-DD'),
        type: 'image',
        newsType: 'platform',
      },
      {
        message: `Te invitamos a tener actualizada tu plataforma de Softgas en unos pasos, para ello anexamos un video que detalla cómo hacerlo.
                  Cualquier duda, acércate a nosotros al siguiente correo, <a href = "mailto: softgas.at@gmail.com">softgas.at@gmail.com</a> y te brindaremos la atención que necesitas.
                  <span class="d-block mt-2">¡Seguimos en mejora continua!</span>`,
        image: '<iframe src="https://www.youtube.com/embed/045BB50lon0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
        created_at: moment().format('LL'),
        date: moment().format('YYYY-MM-DD'),
        type: 'youtube',
        newsType: 'platform',
      },
    );
  }
}
